import { render, staticRenderFns } from "./GameLogin.vue?vue&type=template&id=3e8abe96&scoped=true&"
import script from "./GameLogin.vue?vue&type=script&lang=js&"
export * from "./GameLogin.vue?vue&type=script&lang=js&"
import style0 from "./GameLogin.vue?vue&type=style&index=0&id=3e8abe96&scoped=true&lang=css&"
import style1 from "./GameLogin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8abe96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCol,VContainer,VIcon,VRow,VSpacer,VTextField})
